import React from 'react';
import { BUBBLE_BGND } from "../../styles/styleUtils"

const TriangleShape = () => {
  return (
      <svg width="15" height="25" viewBox="0 0 15 25">
        <polygon
          points="15,0 15,15 0,15"
          fill={BUBBLE_BGND}
        />
    </svg>
  );
};

export default TriangleShape;
